import * as Collections from '@pkg/utils/collections';

/**
 * @param {String} type
 * @param {Object} snapshot
 * @param {String} input
 */
export default function update(type, snapshot, { uuid, ...input }) {
  const existing = snapshot.entities[type][uuid];
  if (!existing) {
    console.debug('Snapshot.actions.update: No existing entity found');
    return;
  }

  const { properties, ...rest } = input;
  const mutated = { ...existing, ...rest };

  if (properties) {
    const mutating = Collections.keyBy(mutated.properties, 'key');

    Object.keys(properties).forEach((action) => {
      properties[action].forEach((property) => {
        switch (action) {
          case 'create':
          case 'update':
            mutating[property.key] = property;
            return;

          case 'remove':
            delete mutating[property];
            break;
        }
      });
    });

    mutated.properties = Object.values(mutating);
  }

  snapshot.entities[type][uuid] = mutated;
}
